module.exports = __webpack_public_path__ + "static/media/connections-android.2f3946c2.webp";